import React from "react";
import LoginWrapper from "../hoc/LoginWrapper";
import deLogo from "../../assets/logo.png";
import Card from "../shared/Card";
import Divider from "../shared/Divider";
import { resetPassFields } from "../../utils/utils";
import FormField from "./utilComponents/FormField";
import { Link } from "react-router-dom";

import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormButton from "../shared/FormButton";
import { useDispatch, useSelector } from "react-redux";
import {
  resetPassword,
  verifyNewPassword,
} from "../../features/auth/actions/auth";

const UsernameSchema = Yup.object().shape({
  username: Yup.string().required("This field is required"),
});

const ResetPassSchema = Yup.object().shape({
  recoveryCode: Yup.string().required("This field is required"),
  new_password: Yup.string()
    .min(8, "Password should be atleast 8 characters in length")
    .max(20, "Password should not exceed 20 characters")
    .required("This field is required"),
  confirm_password: Yup.string()
    .min(8, "Password should be atleast 8 characters in length")
    .max(20, "Password should not exceed 20 characters")
    .required("This field is required")
    .oneOf([Yup.ref("new_password"), null], "Passwords must match"),
});

const ResetPassword = () => {
  const dispatch = useDispatch();
  const flowId = useSelector((state) => state.auth.flowId);
  const loading = useSelector((state) => state.auth.loading);

  return (
    <>
      {!flowId ? (
        <Card>
          <div className="mb-8">
            <div className="font-bold text-lg">Forgot Password?</div>
            <div>Please enter a your username</div>
          </div>
          <Formik
            initialValues={{
              username: "",
            }}
            validationSchema={UsernameSchema}
            onSubmit={(values) => {
              dispatch(resetPassword({ username: values.username }));
            }}
          >
            <Form>
              <FormField
                type="text"
                name="username"
                htmlFor="username"
                placeholder="enter username"
                label="Username"
              />
              <div className="flex justify-start mb-2">
                Instead Sign in? &nbsp;{" "}
                <Link to="/" className="text-[#3e4095]">
                  Click here
                </Link>
              </div>
              <Divider />
              <FormButton buttonText="Reset Password" isSubmitting={loading} />
            </Form>
          </Formik>
        </Card>
      ) : (
        <Card>
          <div className="mb-8">
            <div className="font-bold text-lg">Forgot Password?</div>
            <div>Please enter a new password and confirm it.</div>
          </div>
          <Formik
            initialValues={{
              recoveryCode: "",
              new_password: "",
              confirm_password: "",
            }}
            validationSchema={ResetPassSchema}
            onSubmit={(values) => {
              dispatch(
                verifyNewPassword({
                  flowId,
                  value: values.new_password,
                  recoveryCode: values.recoveryCode,
                })
              );
            }}
          >
            <Form>
              {resetPassFields.map((field) => (
                <FormField key={field.name} {...field} />
              ))}
              <div className="flex justify-start mb-2">
                Instead Sign in? &nbsp;{" "}
                <Link to="/" className="text-[#3e4095]">
                  Click here
                </Link>
              </div>
              <Divider />
              <FormButton buttonText="Verify Password" isSubmitting={loading} />
            </Form>
          </Formik>
        </Card>
      )}
    </>
  );
};

export default LoginWrapper(ResetPassword);
